export { SidebarFavoritesEntity } from './sidebar-favorites';
